<template>
  <svg width="40px" height="40px" viewBox="10 0 63 63" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-49.000000, -552.000000)">
        <g transform="translate(-3.000000, 330.554113)">
          <g transform="translate(52.125932, 221.989994)">
            <polygon points="0 0 62.2150707 0 62.2150707 62.4346859 0 62.4346859"></polygon>
            <path d="M31.1075353,5.78098944 C20.9161142,5.78098944 12.6734403,13.9235131 12.6734403,23.9911062 C12.6734403,37.6486937 31.1075353,57.8098944 31.1075353,57.8098944 C31.1075353,57.8098944 49.5416304,37.6486937 49.5416304,23.9911062 C49.5416304,13.9235131 41.2989564,5.78098944 31.1075353,5.78098944 Z M31.1075353,30.4947193 C27.4733852,30.4947193 24.52393,27.5811006 24.52393,23.9911062 C24.52393,20.4011117 27.4733852,17.4874931 31.1075353,17.4874931 C34.7416855,17.4874931 37.6911407,20.4011117 37.6911407,23.9911062 C37.6911407,27.5811006 34.7416855,30.4947193 31.1075353,30.4947193 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
